package chand.wordvoyage.viewmodel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import chand.wordvoyage.data.WordEntry
import chand.wordvoyage.repository.FirestoreRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

sealed class WordHistoryState {
    object Loading : WordHistoryState()
    data class Success(val entries: List<WordEntry>) : WordHistoryState()
    data class Error(val message: String) : WordHistoryState()
    object Empty : WordHistoryState()
}

class WordHistoryViewModel(
    private val firestoreRepository: FirestoreRepository,
    private val userId: String
) : ViewModel() {

    private val _historyState = MutableStateFlow<WordHistoryState>(WordHistoryState.Loading)
    val historyState: StateFlow<WordHistoryState> = _historyState

    init {
        loadHistory()
    }

    fun loadHistory() {
        viewModelScope.launch {
            _historyState.value = WordHistoryState.Loading
            firestoreRepository.getWordHistory(userId)
                .onSuccess { entries ->
                    _historyState.value = if (entries.isEmpty()) {
                        WordHistoryState.Empty
                    } else {
                        // Sort by savedAt descending (most recent first)
                        WordHistoryState.Success(entries.sortedByDescending { it.savedAt })
                    }
                }
                .onFailure { error ->
                    _historyState.value = WordHistoryState.Error(error.message ?: "Failed to load history")
                }
        }
    }

    fun deleteWord(word: String) {
        viewModelScope.launch {
            firestoreRepository.deleteWordEntry(userId, word)
                .onSuccess {
                    loadHistory() // Refresh the list after successful deletion
                }
                .onFailure { error ->
                    println("Failed to delete word: ${error.message}")
                }
        }
    }
}

